<template>
  <nav>
    <router-link :to="{ name: 'show-list' }">What's On</router-link>
    <router-link :to="{ name: 'basket' }">Basket {{ basketCount }}</router-link>
    <router-link v-if="loggedIn" :to="{ name: 'profile' }">Profile</router-link>
    <router-link v-else :to="{ name: 'login' }" class="login-link"
      >Login</router-link
    >
  </nav>
</template>
<script>
import { mapState } from 'vuex';
import { authComputed } from '../vuex/helpers.js';
export default {
  computed: {
    basketCount() {
      return this.basket.count ? '(' + this.basket.count + ')' : '';
    },
    ...authComputed,
    ...mapState(['basket'])
  }
};
</script>
